<span class="counter-badge" [class.counter-badge--accent]="variant() === 'accent'">{{ label() }}</span>
